export default __webpack_public_path__ + "static/media/CNo.87-2.f96c3bf7.jpg";